import { render, staticRenderFns } from "./identification-info.vue?vue&type=template&id=1781fa01"
import script from "./identification-info.vue?vue&type=script&lang=js"
export * from "./identification-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports